import { render, staticRenderFns } from "./PathwayPurchaseModal.vue?vue&type=template&id=67fd4a56&scoped=true"
import script from "./PathwayPurchaseModal.vue?vue&type=script&lang=js"
export * from "./PathwayPurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./PathwayPurchaseModal.vue?vue&type=style&index=0&id=67fd4a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd4a56",
  null
  
)

export default component.exports